import React from 'react';
import { cn } from '@/utils/helpers';
import { formatHelpers } from '@/utils/helpers';
import { RechargeProductConfig } from '@/services/types';

export interface SimplePackageSelectorProps {
  packages: RechargeProductConfig[];
  selectedPackageId?: string;
  onSelect: (packageId: string) => void;
  loading?: boolean;
}

export const SimplePackageSelector: React.FC<SimplePackageSelectorProps> = ({
  packages,
  selectedPackageId,
  onSelect,
  loading = false
}) => {

  if (loading) {
    return (
      <div className="space-y-3">
        <label className="block text-base font-semibold text-gray-700">
          充值套餐
        </label>
        <div className="animate-pulse bg-gray-200 h-14 rounded-lg"></div>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">
        充值套餐
      </label>
      
      <select
        value={selectedPackageId || ''}
        onChange={(e) => onSelect(e.target.value)}
        className={cn(
          "w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm",
          "focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white",
          "hover:border-gray-400 transition-colors"
        )}
      >
        {packages.map((pkg) => (
          <option key={pkg.recharge_product_id} value={pkg.recharge_product_id}>
            {pkg.recharge_product_name} - {formatHelpers.formatPrice(pkg.cny_price)}
          </option>
        ))}
      </select>
    </div>
  );
};